import React from 'react';

export const Process = ({ t }) => {
  return (
    <section id="process" className="py-24 bg-[#001f3f] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.process.title}
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            {t.process.subtitle}
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto">
          {t.process.steps.map((step, index) => (
            <div 
              key={`step-${step.number}-${index}`}
              className="relative mb-12 last:mb-0 group"
            >
              <div className="flex flex-col md:flex-row items-start gap-6">
                {/* Step Number - More interactive */}
                <div className="flex-shrink-0">
                  <div className="relative">
                    <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#FFD700] flex items-center justify-center shadow-2xl shadow-[#D4AF37]/30 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                      <span className="text-3xl font-bold text-[#001f3f] group-hover:scale-110 transition-transform duration-300">
                        {step.number}
                      </span>
                    </div>
                    {index < t.process.steps.length - 1 && (
                      <div className="hidden md:block absolute top-24 left-1/2 -translate-x-1/2 w-1 h-16 bg-gradient-to-b from-[#D4AF37] to-transparent group-hover:h-20 transition-all duration-300"></div>
                    )}
                  </div>
                </div>

                {/* Step Content */}
                <div className="flex-1 bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 hover:bg-white/10 group-hover:translate-x-2 group-hover:shadow-xl">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#D4AF37] transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-slate-300 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
